<template>
  <div>
    <!-- route {{ $route.query }} -->
    <v-card class="mx-10 md:mx-32 p-10 my-10">
      <div
        class="flex justify-center text-xl sm:text-3xl font-noto-sans font-bold"
      >
        Statement of Account Page
      </div>

      <v-card-text>
        <div class="text-md sm:text-xl font-light">
          Please click if you want to request for a statement of account.
        </div>
      </v-card-text>
      <div class="mt-4">
        <button
          :disabled="disabled"
          @click="openSoaDialog"
          class="text-sm sm:text-2xl w-full py-2 text-white rounded-md !text-wrap !whitespace-normal !break-words text-center bg-[#ED7D31]"
          color="primary"
        >
          Yes, I want to request for a statement of account.
        </button>
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <div class="bg-white p-10">
        <div class="text-left font-bold">MESSAGE CONFIRMATION</div>
        <div class="py-4">
          Are you sure you want to request for a Statement of Account?
        </div>
        <v-btn @click="dialog = false" class="mb-2 w-full" outlined>No</v-btn>
        <v-btn @click="sendSoa" class="w-full" elevation="" dark color="blue"
          >Yes</v-btn
        >
      </div>
    </v-dialog>
    <v-dialog
      v-model="successAlertDialog"
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <div class="bg-white p-10">
        <div class="text-left font-bold">Success!</div>
        <div class="py-4">
          {{ successAlertDialogText }}
        </div>
        <v-btn
          @click="returnToCustomerDashboard"
          class="w-full"
          elevation=""
          dark
          color="blue"
          >Ok</v-btn
        >
      </div>
    </v-dialog>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import SecureStorage from "../../utils/secureStorage";
export default {
  data() {
    return {
      successAlertDialog: false,
      successAlertDialogText: "",
      disabled: false,
      dialog: false,
      snackbarText: "",
      snackbar: false,
    };
  },
  methods: {
    openSoaDialog() {
      this.dialog = true;
    },
    returnToCustomerDashboard() {
      this.successAlertDialog = false;
      this.successAlertDialogText = "";
      this.$router.push({
        name: "Customer Dashboard",
        query: {
          cc: this.$route.query.cc,
          cn: this.$route.query.cn,
        },
      });
    },
    sendSoa() {
      
      let data = {
        user_id: SecureStorage.getItem("auth").userId,
        status_id: 1,
        remarks_id: 1,
        classification_id: 9,
        department_id: 10,
        subject: "Statement of Account Request",
        customer_code: this.$route.query.cc,
        contract_number: this.$route.query.cn,
        property: SecureStorage.getItem("auth").property,
        buyer_name: SecureStorage.getItem("auth").buyerName,
        email: SecureStorage.getItem("auth").email,
      };

      try {
        axios.post("/tickets/add", data).then((res) => {
          if (res.data.status) {
            console.log("Adding ticket")
            this.disabled = true;
            this.dialog = false;
            this.successAlertDialog = true;
            this.successAlertDialogText = res.data.message;

            //   this.$router.push("/home/customer-dashboard");
            // }, 3000);
          } else {
            this.snackbar = true;
            this.snackbarText = res.data.message;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
